var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterlkdnicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7633 19.9876L20.7683 19.9868V12.6608C20.7683 9.07691 19.9967 6.31616 15.8069 6.31616C13.7927 6.31616 12.4411 7.42146 11.8892 8.46933H11.831V6.65075H7.8584V19.9868H11.9949V13.3833C11.9949 11.6446 12.3245 9.96332 14.4777 9.96332C16.5993 9.96332 16.6309 11.9475 16.6309 13.4948V19.9876H20.7633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12256 6.65161H5.2641V19.9876H1.12256V6.65161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19118 0.0123291C1.86699 0.0123291 0.79248 1.08683 0.79248 2.41103C0.79248 3.73523 1.86699 4.8322 3.19118 4.8322C4.51538 4.8322 5.58988 3.73523 5.58988 2.41103C5.58905 1.08683 4.51454 0.0123291 3.19118 0.0123291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_1884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9753,
    height: 19.9753,
    fill: "white",
    transform: "translate(0.79248 0.0123291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlkdnicon);
export default __webpack_public_path__ + "static/media/footerlkdnicon.0ac305d0863cccbddb047ac3f95130c3.svg";
export { ForwardRef as ReactComponent };